import { createActionsGroup } from 'utils/redux-utils'

export const campaignsActions = createActionsGroup('CAMPAIGNS')
export const campaignDetailsActions = createActionsGroup('CAMPAIGN_DETAILS')
export const campaignProductsActions = createActionsGroup('CAMPAIGN_PRODUCTS')
